import { useState, type ReactElement } from "react";

import DocumentSheet from "@/shared/components/document-viewer/DocumentSheet";
import type { ContactSourceDocument } from "@/shared/types/estateContact";

interface UseDocumentSheetResult {
  openDocument: (sourceDocument: ContactSourceDocument | null | undefined) => void;
  documentSheet: ReactElement | null;
}

export function useDocumentSheet(estateId?: number): UseDocumentSheetResult {
  const [doc, setDoc] = useState<ContactSourceDocument | null>(null);

  const openDocument = (sourceDocument: ContactSourceDocument | null | undefined) => {
    if (!sourceDocument?.created_at) return;
    const createdDate = new Date(sourceDocument.created_at);
    if (isNaN(createdDate.getTime())) return;
    setDoc(sourceDocument);
  };

  const documentSheet = doc ? (
    <DocumentSheet
      isOpen={!!doc}
      setIsOpen={(open) => !open && setDoc(null)}
      documentId={doc.id}
      documentName={doc.display_name || doc.file_name}
      documentCreatedAt={new Date(doc.created_at)}
      estateId={estateId}
    />
  ) : null;

  return { openDocument, documentSheet };
}
